<template>
	<BaseCmsLabel code="support" class="support" tag="div" />
</template>

<style scoped lang="less">
	.support{
		font-size: 14px;
		@media (max-width: @m){font-size: 13px; text-align: center;}
	}
	:deep(p){
		padding: 0;
		&:first-child{
			font-size: 20px; padding-bottom: 6px;
			@media (max-width: @m){font-size: 18px; padding-bottom: 5px;}	
		}
	}
	:deep(a[href*=tel]){
		color: var(--blue); font-size: 18px; font-weight: bold; text-decoration: none;
		@media (max-width: @m){font-size: 16px;}
	}
	:deep(a[href*=mailto]){
		color: var(--textColor); text-decoration-color: var(--blue2); text-decoration-thickness: 1px; text-underline-offset: 4px;
		&:hover{color: var(--blue);}
	}
</style>